import { Row, Col } from 'antd';
import {
  ProductGuidelineCardHorizontal,
  ProductGuidelineCardVertical,
  IProductType,
} from './ProductGuidelineCard';

interface IProps {
  data: IProductType[];
  layout?: 'horizontal' | 'vertical';
}

/**
 * 文档中心 产品按照一级分类展示
 */
const ProductGuideline = ({ data, layout = 'vertical' }: IProps) => {
  if (layout === 'vertical') {
    return (
      <div>
        {data.map((item) => (
          <ProductGuidelineCardVertical key={item.productType} data={item} />
        ))}
      </div>
    );
  } else {
    return (
      <Row gutter={56}>
        {data.map((item) => (
          <Col key={item.productType}>
            <ProductGuidelineCardHorizontal data={item} />
          </Col>
        ))}
      </Row>
    );
  }
};

export default ProductGuideline;
